import React from 'react';
import camelcase from 'camelcase-es5';
import Box from '../../components/Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { TUtils } from '../../types/TUtils';

type TCard = {
  id?: string;
  as?: keyof React.JSX.IntrinsicElements;
  padding?: string;
  kind?: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
} & TUtils;

const Card = ({ as = 'article', padding = '', kind = '', ...rest }: TCard) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind,
    utilities: padding && camelcase(`padding-${padding}`),
  });
  return <Box {...rest} {...conditionalProps} as={as} name="Card" />;
};

export default React.memo(Card);
